"use strict";
/**
 * @module Services.TopicNotifications
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a TOPIC_NOTIFICATION_EVENTS request.
 */
var TopicNotificationEvent = /** @class */ (function () {
    /**
     * Create a new TopicNotificationEvent instance
     *
     * @param cid            the conversation ID
     * @param path           the path that the topic notification refers to
     * @param type           the notification type
     * @param specification  the topic specification
     */
    function TopicNotificationEvent(cid, path, type, specification) {
        this.cid = cid;
        this.path = path;
        this.type = type;
        this.specification = specification;
        this.isDescendantEvent = false;
    }
    return TopicNotificationEvent;
}());
exports.TopicNotificationEvent = TopicNotificationEvent;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-notifications/topic-notification-event.js
// module id = 2011
// module chunks = 1